import React from 'react';
import { QuestRoute } from '../../../api/QuestRoutes';
import Table from '../../../table/Table';
import { formatPhone, generateId, shortHandDate, shortHandDateTime } from '../../../utility/functions';
import Button from '../../../forms/Button';
import { voidCode } from '../../codes/Codes';
import GetState from '../../../GetState';
import Collapsible from '../../../layout/Collapsable';
import Row from '../../../layout/Row';
import HamQuest from '../../../api/HamQuestGiver';
import Icon from '../../../forms/Icon';
import ModalFactory from '../../../Modal';


const BundleCodes = ({ ...props }) => {

    const [data, refreshData] = GetState(QuestRoute.codes.bundleGrid)

    const resendBundle = (code, phoneNumber) => {
        ModalFactory.confirmAndProcess({
            confirmation: {
                title: `Resend Bundle Code?`,
                body: (<span>Are you sure you want to send a Bundle Code text?</span>),
                type: 'warning',
            },
            promise: {
                title: 'Sending',
                body: `Sending, please wait.`,
                callback: () => HamQuest.post(QuestRoute.codes.resendBundle(code), { phoneNumber })
            },
            confirmed: {
                title: 'Success',
                body: `Bundle Code has been sent.`,
                type: 'success'
            }
        })
    }

    return (
        <Table
            config={{
                // label: 'Bundle Code',
                colSpacing: [20, 10, 10, 10],
                data: data,
                headers: [
                    {
                        label: 'Code',
                        propKey: 'code',
                    }, {
                        label: 'Phone Number',
                        propKey: 'phone',
                    }, {
                        label: 'Purchased At',
                        propKey: 'purchaseLocation',
                    }, {
                        label: 'Item',
                        propKey: 'kioskItemName',
                    }, {
                        label: 'Expiration',
                        propKey: 'expirationDate',
                    }, {
                        label: 'Issued',
                        propKey: 'issueDate',
                    }, {
                        label: 'Last Used',
                        propKey: 'lastUsedDate',
                    }, {
                        label: 'Use Count',
                        propKey: 'useCount',
                    }, {
                        label: 'Max Uses',
                        propKey: 'maxUses',
                    }, {
                        label: 'Void',
                        // propKey: 'isVoided',
                    },
                ],
                renderFormat: (e) => (
                    <tr key={generateId()}>
                        <td>
                            {e.useList?.length ?
                                <Collapsible label={e.code}>
                                    {e.useList.reverse().map(f => (
                                        <Row key={generateId}>{f.locationName} - {shortHandDateTime(f.localTime)}</Row>
                                    ))}
                                </Collapsible> : e.code}
                        </td>
                        <td>
                            <Row>
                                {formatPhone(e.phone)}
                                {e.useCount !== e.maxUses && e.phone && !e.isVoided && (
                                    < Icon
                                        onClick={() => resendBundle(e.code, e.phone)}
                                        icon='comment'
                                        style={{ cursor: 'pointer' }}
                                        title='Resend Bundle Code'
                                    />
                                )}
                            </Row>
                        </td>
                        <td>{e.purchaseLocation}</td>
                        <td>{e.kioskItemName}</td>
                        <td>{shortHandDate(e.expirationDate)}</td>
                        <td>{shortHandDate(e.issueDate)}</td>
                        <td>{shortHandDate(e.lastUsedDate)}</td>
                        <td>{e.useCount}</td>
                        <td>{e.maxUses}</td>
                        <td>{!e.isVoided ? <Button onClick={() => voidCode(e.code).then(() => refreshData())}>Void</Button> : 'Voided'}</td>
                    </tr>
                )
            }}
        />
    );
}

export default BundleCodes;